import { FormattedAddress } from '@/components/DataDisplay/FormattedAddress';
import {
  InfoReviewFieldLabel,
  InfoReviewFieldValue,
} from '@/components/Form/Form.styled';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectUser } from '@/redux/user-data/selectors';

import {
  getMailingAddressFromUser,
  getPermanentAddressFromUser,
} from '@/utils/address';
import { getDisplayCountryName, isRemediationCustomer } from '@/utils/user';

import { ReviewCard } from './ReviewCard';
import { SectionProps } from './types';

export function AddressSection({
  currentIndex,
  totalSections,
}: Readonly<SectionProps>) {
  const { t, language } = useTranslate();
  const user = useAppSelector(selectUser);

  const FIELD_PREFIX = 'moreInfo.reviewMyInformation.address.field';
  const showMailingAddress = !isRemediationCustomer(user);

  return (
    <ReviewCard
      title={t('moreInfo.reviewMyInformation.address.title')}
      currentIndex={currentIndex}
      totalSections={totalSections}
    >
      <InfoReviewFieldLabel>
        {t(`${FIELD_PREFIX}.permanentAddress`)}
      </InfoReviewFieldLabel>
      <InfoReviewFieldValue>
        <FormattedAddress
          address={getPermanentAddressFromUser(user)}
          language={language}
        />
      </InfoReviewFieldValue>
      {showMailingAddress && (
        <>
          <InfoReviewFieldLabel>
            {t(`${FIELD_PREFIX}.mailingAddress`)}
          </InfoReviewFieldLabel>
          <InfoReviewFieldValue>
            <FormattedAddress
              address={getMailingAddressFromUser(user)}
              language={language}
            />
          </InfoReviewFieldValue>
        </>
      )}
      <InfoReviewFieldLabel>
        {t(`${FIELD_PREFIX}.countryOfResidence`)}
      </InfoReviewFieldLabel>
      <InfoReviewFieldValue>
        {getDisplayCountryName(user?.residenceCountry, language)}
      </InfoReviewFieldValue>
    </ReviewCard>
  );
}
